import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";

import moment from "moment";

import { CalendarDatepickerComponent } from "../../calendar/calendar-datepicker.component";

@Component({
  selector: "dateinput",
  templateUrl: "./dateinput.component.html",
  styleUrls: ["./dateinput.component.scss"],
})
export class DateinputComponent {
  @ViewChild(CalendarDatepickerComponent)
  datePicker: CalendarDatepickerComponent;

  @Input()
  current: moment.Moment;

  @Input()
  noTimePicker = true;

  @Input()
  disabled = false;

  @Input()
  overrideStyle: { [key: string]: string } = null;

  @Input()
  datePickerOverrideStyle: { [key: string]: string } = null;

  @Output()
  currentChange = new EventEmitter<moment.Moment>();

  constructor(private elementRef: ElementRef) {}

  hideDatepicker() {
    this.datePicker.hide();
  }

  onClickedOutside() {
    this.hideDatepicker();
  }

  onDatepickerApply(newDate: moment.Moment) {
    this.current = newDate;
    this.currentChange.emit(newDate);

    this.hideDatepicker();
  }

  openDatepicker() {
    this.datePicker.show();
  }

  formatCurrent() {
    if (this.noTimePicker) {
      return this.current ? this.current.format("MM/DD/Y") : "---";
    } else {
      return this.current ? this.current.format("MM/DD/Y HH:mm") : "---";
    }
  }
}
